module.exports = __webpack_public_path__ + "static/media/swimmer.bd52c7d3.svg";